import {
  ColumnHeader, HeaderColumnKeyEnum, HeaderDataTypeEnum, HeaderNodeTypeEnum,
} from '../types/columnHeader';

export const ADDRESS_HEADERS: Omit<ColumnHeader, 'order'>[] = [
  {
    columnKey: HeaderColumnKeyEnum.ADDRESS,
    matchKeys: ['full address', 'address', 'location', 'street address'],
    label: 'Address',
    columnWidth: 400,
    nodePath: 'locations',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.STRING,
    asyncValidation: true,
    isLocationHeader: true,
  },
  {
    columnKey: HeaderColumnKeyEnum.UNIT_NUMBER,
    matchKeys: ['unit number', 'suite number'],
    label: 'Unit Number',
    nodePath: 'locations',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.STRING,
    asyncValidation: true,
    isLocationHeader: true,
  },
  {
    columnKey: HeaderColumnKeyEnum.CITY,
    matchKeys: ['city'],
    label: 'City',
    nodePath: 'locations',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.STRING,
    asyncValidation: true,
    isLocationHeader: true,
  },
  {
    columnKey: HeaderColumnKeyEnum.STATE,
    matchKeys: ['state', 'province'],
    label: 'State',
    nodePath: 'locations',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.STRING,
    asyncValidation: true,
    isLocationHeader: true,
  },
  {
    columnKey: HeaderColumnKeyEnum.ZIP_CODE,
    matchKeys: ['zip code', 'postal code'],
    label: 'Zip Code',
    nodePath: 'locations',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.STRING,
    asyncValidation: true,
    isLocationHeader: true,
  },
  {
    columnKey: HeaderColumnKeyEnum.COUNTRY,
    matchKeys: ['country'],
    label: 'Country',
    nodePath: 'locations',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.STRING,
    asyncValidation: true,
    isLocationHeader: true,
  },
];

export const LAT_LNG_HEADERS: Omit<ColumnHeader, 'order'>[] = [
  {
    columnKey: HeaderColumnKeyEnum.LATITUDE,
    matchKeys: ['latitude'],
    label: 'Latitude',
    nodePath: 'locations',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.NUMBER,
    dependsOn: HeaderColumnKeyEnum.LONGITUDE,
    isLocationHeader: true,
  },
  {
    columnKey: HeaderColumnKeyEnum.LONGITUDE,
    matchKeys: ['longitude'],
    label: 'Longitude',
    nodePath: 'locations',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.NUMBER,
    dependsOn: HeaderColumnKeyEnum.LATITUDE,
    isLocationHeader: true,
  },
];


export const TIME_WINDOW_HEADERS: Omit<ColumnHeader, 'order'>[] = [
  {
    columnKey: HeaderColumnKeyEnum.START_TIME,
    matchKeys: ['start time', 'time window start', 'from', 'earliest'],
    label: 'Time Window Start',
    nodePath: 'timeWindows',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.TIME,
    dependsOn: HeaderColumnKeyEnum.END_TIME,
    isLocationHeader: false,
  },
  {
    columnKey: HeaderColumnKeyEnum.END_TIME,
    matchKeys: ['end time', 'time window end', 'to', 'latest'],
    label: 'Time Window End',
    nodePath: 'timeWindows',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.TIME,
    dependsOn: HeaderColumnKeyEnum.START_TIME,
    isLocationHeader: false,
  },
];

export const OTHER_VISIT_HEADERS: Omit<ColumnHeader, 'order'>[] = [
  {
    columnKey: HeaderColumnKeyEnum.CUSTOMER_ORDER_NUMBER,
    matchKeys: ['order id', 'id', 'order number', 'invoice', 'invoice number', 'purchase order'],
    label: 'Order Number',
    nodePath: HeaderColumnKeyEnum.CUSTOMER_ORDER_NUMBER,
    nodeType: HeaderNodeTypeEnum.NONE,
    dataType: HeaderDataTypeEnum.STRING,
    isLocationHeader: false,
  },
  {
    columnKey: HeaderColumnKeyEnum.NAME,
    matchKeys: ['stop name', 'name', 'full name', 'customer name', 'stop', 'customer', 'visit name'],
    label: 'Customer Name',
    nodePath: HeaderColumnKeyEnum.NAME,
    nodeType: HeaderNodeTypeEnum.NONE,
    dataType: HeaderDataTypeEnum.STRING,
    isLocationHeader: false,
  },
  {
    columnKey: HeaderColumnKeyEnum.PHONE,
    matchKeys: ['phone', 'phone number'],
    label: 'Phone',
    nodePath: HeaderColumnKeyEnum.PHONE,
    nodeType: HeaderNodeTypeEnum.NONE,
    dataType: HeaderDataTypeEnum.STRING,
    isLocationHeader: false,
  },
  {
    columnKey: HeaderColumnKeyEnum.EMAIL,
    matchKeys: ['email', 'email address', 'e-mail', 'e-mail address'],
    label: 'Email',
    nodePath: HeaderColumnKeyEnum.EMAIL,
    nodeType: HeaderNodeTypeEnum.NONE,
    dataType: HeaderDataTypeEnum.STRING,
    isLocationHeader: false,
  },
  {
    columnKey: HeaderColumnKeyEnum.DURATION,
    matchKeys: ['duration', 'service time', 'time'],
    label: 'Duration',
    nodePath: HeaderColumnKeyEnum.DURATION,
    nodeType: HeaderNodeTypeEnum.NONE,
    dataType: HeaderDataTypeEnum.NUMBER,
    isLocationHeader: false,
  },
  {
    columnKey: HeaderColumnKeyEnum.LOAD,
    matchKeys: ['load', 'units', 'boxes', 'bags'],
    label: 'Load',
    nodePath: HeaderColumnKeyEnum.LOAD,
    nodeType: HeaderNodeTypeEnum.NONE,
    dataType: HeaderDataTypeEnum.NUMBER,
    isLocationHeader: false,
  },
  {
    columnKey: HeaderColumnKeyEnum.INSTRUCTIONS,
    matchKeys: ['note', 'notes', 'comment', 'comments', 'memo', 'instructions'],
    label: 'Notes',
    columnWidth: 400,
    nodePath: HeaderColumnKeyEnum.INSTRUCTIONS,
    nodeType: HeaderNodeTypeEnum.NONE,
    dataType: HeaderDataTypeEnum.STRING,
    isLocationHeader: false,
  },
  {
    columnKey: HeaderColumnKeyEnum.DELIVERY_DATE,
    matchKeys: ['fulfillment date', 'fulfilment date', 'delivery date', 'service date', 'due date'],
    label: 'Delivery Date',
    nodePath: HeaderColumnKeyEnum.DELIVERY_DATE,
    nodeType: HeaderNodeTypeEnum.NONE,
    dataType: HeaderDataTypeEnum.DATE,
    isLocationHeader: false,
  },
  {
    columnKey: HeaderColumnKeyEnum.TAGS,
    matchKeys: ['tags', 'tag', 'type', 'types'],
    label: 'Tags',
    nodePath: 'tags',
    nodeType: HeaderNodeTypeEnum.ARRAY,
    dataType: HeaderDataTypeEnum.STRING,
    isLocationHeader: false,
  },
];

export const ADDRESS_COLUMN_KEYS = ADDRESS_HEADERS.map((h) => h.columnKey);
export const LAT_LNG_COLUMN_KEYS = LAT_LNG_HEADERS.map((h) => h.columnKey);
export const PACKAGE_COLUMN_KEYS: (HeaderColumnKeyEnum | string)[] = [HeaderColumnKeyEnum.BARCODE];

const RESERVED_KEYWORDS = ['barcode', 'barcodes'];

const createCustomHeaders = (customFields: string[]) => {
  const customHeaders: Omit<ColumnHeader, 'order'>[] = [];
  customFields.forEach((customField) => {
    if (RESERVED_KEYWORDS.includes(customField.toLowerCase())) {
      return;
    }
    customHeaders.push({
      columnKey: customField,
      matchKeys: [],
      label: customField,
      columnWidth: 400,
      nodePath: HeaderColumnKeyEnum.CUSTOM_FIELDS,
      nodeType: HeaderNodeTypeEnum.OBJECT,
      dataType: HeaderDataTypeEnum.STRING,
      isLocationHeader: false,
    });
  });
  return customHeaders;
};

export const PACKAGE_HEADERS: Omit<ColumnHeader, 'order'>[] = [
  {
    columnKey: HeaderColumnKeyEnum.BARCODE,
    matchKeys: ['barcode', 'barcodes'],
    label: 'Barcode',
    nodePath: 'packages',
    nodeType: HeaderNodeTypeEnum.ARRAY_OF_OBJECTS,
    dataType: HeaderDataTypeEnum.STRING,
    isLocationHeader: false,
  },
];

const getColumnHeaders = (customFields: string[]): ColumnHeader[] => {
  const columnHeaders = [
    ...ADDRESS_HEADERS,
    ...LAT_LNG_HEADERS,
    ...PACKAGE_HEADERS,
    ...TIME_WINDOW_HEADERS,
    ...OTHER_VISIT_HEADERS,
    ...createCustomHeaders(customFields),
  ];

  return columnHeaders.map((h, index): ColumnHeader => ({
    ...h,
    order: index,
  }));
};

export default getColumnHeaders;
